import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { AppointmentService } from '@avanta/shared/services/appointments';
import { type BookingOptions } from '@avanta/shared/types/appointments';

export const useFetchSpecialitiesByPsycho = ({
  psychologistId,
  insurance = false,
}: {
  psychologistId: string;
  insurance?: boolean;
}): UseQueryResult<BookingOptions> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_SPECIALITIES_BY_PSYCHO, psychologistId, insurance],
    queryFn: () => AppointmentService.getBookingOptionsByPsycho({ psychologistId, insurance }),
    select: response => response.data,
    enabled: !!psychologistId,
  });
